import { FC } from "react";

import ConfirmationPopover from "../../../../components/ConfirmationPopover";
import { useUpdatePlaceStatus } from "../../utils/useUpdatePlaceStatus";

const PlacesEnable: FC<PlacesActionsProps> = ({ selectedIds }) => {
  const handleChangeStatus = useUpdatePlaceStatus();

  return (
    <ConfirmationPopover
      onConfirm={() => handleChangeStatus(selectedIds, true)}
      message="Are you sure you want to disable place?"
      buttonText="Disable"
      buttonVariant="contained"
      buttonColor="primary"
    />
  );
};

interface PlacesActionsProps {
  selectedIds: string[];
}

export default PlacesEnable;
